import { render } from "./flightInfoPage.vue?vue&type=template&id=58fff344&scoped=true"
import script from "./flightInfoPage.vue?vue&type=script&lang=js"
export * from "./flightInfoPage.vue?vue&type=script&lang=js"

import "./flightInfoPage.vue?vue&type=style&index=0&id=58fff344&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58fff344"]])

export default __exports__